import { JsonPipe, NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, input, signal } from '@angular/core';
import { MatAccordion, MatExpansionModule } from '@angular/material/expansion';
import { CookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { SafePipe } from '@teamfoster/sdk/text-utility';
import { exampleData, randomExampleContent } from 'src/app/styleguide/exampledata/example-data';

@Component({
  selector: 'app-content-accordeon',
  standalone: true,
  imports: [StripEmbedPipe, ResizeHtmlImagesPipe, SafePipe, MatAccordion, MatExpansionModule, JsonPipe, NgClass],
  templateUrl: './content-accordeon.component.html',
  styleUrl: './content-accordeon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentAccordeonComponent {
  @Input() datatitle?: string;
  @Input({
    transform: (v: string | boolean) => !!v,
  })
  isopen = false; // legacy
  @Input({
    transform: (v: string | boolean) => !!v,
  })
  dataisopen = false;
}
